import { useEffect, useState } from 'react'
import { useAppDispatch, useAppSelector } from '../app/hooks';
import { EditWorkoutAsync, GetInstructorAsync, GetSingleWorkoutSecuredAsync, GetWorkoutTypesAsync, selectEditFlag, selectInstructorList, selectSingleWorkout, selectWorkoutTypesList, setEditFlag } from '../features/add_workout/workoutSlice';
import { changeDateFormat } from '../app/consts';
import { Link, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Button, Checkbox, FormControlLabel, MenuItem, TextField } from '@mui/material';
import emailjs from '@emailjs/browser'
import styles from './style/editWorkout.module.css'
import CustomTextField from './CustomTextField';

const EditWorkout = () => {
    const editFlag = useAppSelector(selectEditFlag);
    const currentWorkout = useAppSelector(selectSingleWorkout);
    const instructors = useAppSelector(selectInstructorList);
    const workoutTypes = useAppSelector(selectWorkoutTypesList);
    const dispatch = useAppDispatch();
    let WorkoutId = useParams().workoutId;
    const [workoutDate, setDate] = useState("");
    const [workoutTime, setTime] = useState("");
    const [WorkoutLocation, setWorkoutLocation] = useState("");
    const [Instructor, setInstructor] = useState("")
    const [MaximumParticipants, setMaximumParticipants] = useState(0);
    const [Notes, setNotes] = useState("");
    const [Terms, setTerms] = useState("");
    const [Type, setType] = useState("")
    const [FullForm, setFullForm] = useState(false);
    const [IsActive, setIsActive] = useState(true);
    const [hold, setHold] = useState(true)

    useEffect(() => {
        dispatch(GetWorkoutTypesAsync()).unwrap().catch((err) => console.error("Handled error:", err));
        dispatch(GetInstructorAsync()).unwrap().catch((err) => console.error("Handled error:", err));
        dispatch(GetSingleWorkoutSecuredAsync(WorkoutId as string)).unwrap().catch((err) => console.error("Handled error:", err));
        // eslint-disable-next-line
    }, [editFlag])

    emailjs.init("y7dwm07pNohWq81rU");

    useEffect(() => {
        if (currentWorkout) {
            setVariables();
            setTimeout(() => {
                setHold(false)
            }, 250);
        }
        // eslint-disable-next-line
    }, [currentWorkout]);

    const setVariables = () => {
        setDate(currentWorkout?.date === undefined ? "" : currentWorkout?.date)
        setTime(currentWorkout?.time === undefined ? "" : currentWorkout?.time)
        setWorkoutLocation(currentWorkout?.location === undefined ? "" : currentWorkout?.location)
        setInstructor(currentWorkout?.instructor?.id === undefined ? "" : currentWorkout?.instructor?.id)
        setMaximumParticipants(currentWorkout?.maximumParticipants === undefined ? 0 : currentWorkout?.maximumParticipants)
        setNotes((currentWorkout?.notes === undefined || currentWorkout?.notes === null) ? "" : currentWorkout?.notes)
        setTerms((currentWorkout?.terms === undefined || currentWorkout?.terms === null) ? "" : currentWorkout?.terms)
        setType(currentWorkout?.type?.id === undefined ? "" : currentWorkout?.type?.id)
        setFullForm(currentWorkout?.fullForm === undefined ? false : currentWorkout?.fullForm)
        setIsActive(currentWorkout?.isActive === undefined ? false : currentWorkout?.isActive)

    }

    const restVariables = () => {
        setDate("")
        setTime("")
        setWorkoutLocation("")
        setInstructor("")
        setMaximumParticipants(0)
        setNotes("")
        setTerms("")
        setType("")
        setFullForm(false)
        setIsActive(true)
    }

    const handleSuccess = () => {
        restVariables();
        toast.success("האימון התעדכן בהצלחה!");
        dispatch(setEditFlag());
    }

    const handleSubmit = () => {
        let noErrors = document.querySelector<HTMLInputElement>('form[id="editWorkout"]')?.checkValidity();
        if (noErrors) {
            if (IsActive === false) {
                if (currentWorkout?.currentParticipantsCount !== 0) {
                    if (window.confirm(`שים לב!\nפעולה זו תגרור ביטול של האימון ושליחת דוא"ל לכל המשתתפים הרשומים.\nאנא אשר`)) {
                        currentWorkout?.participantsList?.map((participant) =>
                            emailjs.send("service_1qd2ez8", "template_64ap4yc", {
                                email: participant.email,
                                msg: `שלום ${participant.firstName}\n
                                מצטערים להודיע שאימון מסוג ${currentWorkout?.type?.name} בתאריך ${changeDateFormat(currentWorkout?.date as string)} בשעה ${currentWorkout?.time.slice(0, -3)} בוטל\n
                                במידה ושילמת עבור האימון, ניצור איתך קשר לתיאום החזר כספי\n
                                בברכה,\n
                                מערכת הרשמה`,
                            })
                        )
                    }
                    else {
                        toast.error("הפעולה בוטלה - האימון לא עודכן");
                        return
                    }
                }
            }
            dispatch(EditWorkoutAsync({ id: (`${WorkoutId}`), workout: { 'date': workoutDate, 'time': workoutTime, "instructorId": Instructor, "location": WorkoutLocation, "typeId": Type, "maximumParticipants": MaximumParticipants, "notes": Notes, "terms": Terms, "fullForm": FullForm, "isActive": IsActive } })).unwrap()
                .then(handleSuccess)
                .catch((err) => {
                    toast.error("אירעה שגיאה");
                })

        }
        else
            toast.error("קיימת טעות בטופס, אנא וודא את הפרטים שמולאו");
    }

    return (
        <div style={{ display: 'flex', justifyContent: 'center', textAlign: 'center', }}>
            {hold ?
                <img src='/FadingCircles.gif' alt='spinner' style={{ display: 'block', marginLeft: 'auto', marginRight: 'auto' }} />
                :
                <form id='editWorkout' method='post' onSubmit={(e) => e.preventDefault()} noValidate>
                    <h1>עריכת אימון</h1>
                    <div className={styles.formGrid}>
                        <TextField className={styles.div1} variant="filled" label='תאריך האימון' type='date' value={workoutDate} onChange={(e) => setDate(e.target.value)} required slotProps={{inputLabel:{ shrink: true } }} />
                        <TextField className={styles.div2} variant="filled" label='שעת האימון' type='time' value={workoutTime} onChange={(e) => setTime(e.target.value)} required slotProps={{inputLabel:{ shrink: true } }} />
                        <TextField className={styles.div3} variant="filled" label='מיקום האימון' type='text' value={WorkoutLocation} onChange={(e) => setWorkoutLocation(e.target.value)} required />                
                        <TextField className={styles.div4} variant="filled" label='מדריך האימון' select onChange={(e) => setInstructor(e.target.value)} required value={Instructor === "" ? "" : Instructor}>
                            {instructors !== undefined && instructors.map((value, index) => <MenuItem key={index} value={value.id}>{value.fullName}</MenuItem>)}
                        </TextField>
                        <TextField className={styles.div5} variant="filled" label='סוג האימון' select onChange={(e) => setType(e.target.value)} required value={Type === '' ? '' : Type}>
                            {workoutTypes !== undefined && workoutTypes.map((value, index) => <MenuItem key={index} value={value.id}>{value.name}</MenuItem>)}
                        </TextField>
                        <TextField className={styles.div6} variant="filled" label='כמות מקסימלית של משתתפים באימון' type='number' value={MaximumParticipants === undefined ? "" : MaximumParticipants} onChange={(e) => setMaximumParticipants(+e.target.value)} required />
                        <CustomTextField className={styles.div7} variant="filled" label='הערות' type='text' value={Notes} onChange={(e) => setNotes(e.target.value)}  slotProps={{ htmlInput: { maxLength: 256 } }} counter/>
                        <CustomTextField className={styles.div8} variant="filled" label='תנאים' value={Terms} multiline rows={7} type='text' onChange={(e) => setTerms(e.target.value)} style={{ height: '100%' }} slotProps={{ htmlInput: { maxLength: 1001 } }} counter/>
                        <FormControlLabel className={styles.div9}
                            control={<Checkbox checked={!!FullForm} onChange={() => setFullForm(!FullForm)} />}
                            label="טופס הרשמה מלא"
                            labelPlacement="end"
                        />
                        <FormControlLabel className={styles.div10}
                            control={<Checkbox checked={!! !IsActive} onChange={() => setIsActive(!IsActive)} />}
                            label="אימון מבוטל?"
                            labelPlacement="end"
                        />
                        <div className={styles.div11} style={{}}>
                            <Button type='submit' onClick={() => handleSubmit()} variant="contained" color='success' size='large'>עדכן אימון</Button><br/><br/>
                            <div style={{ display: 'flex', gap: '10px', justifyContent:'center', alignItems: 'center', }}>
                                <Button variant='contained' color='secondary' size='large' ><Link to={`/manageWorkout/participants/${WorkoutId}`} state={{ instructors: instructors, workoutTypes: workoutTypes }} style={{ color: 'white' }}>צפה ברשימת המתאמנים</Link></Button>
                                {/* &emsp; */}
                                <Button variant='contained' color='warning' size='large' ><Link to={'/manageWorkout'} style={{ color: 'white' }}>חזור לרשימת האימונים</Link></Button>
                            </div>
                        </div>
                    </div>
                </form>
            }

        </div>
    )
}

export default EditWorkout